export const urlPayGp = '/paygp'
export const urlGetOrderId = `${urlPayGp}?action=getorderid`
export const merchantName = 'Qatar Insurance Company'
export const GOOGLE_PAY_SCRIPT_ID = 'google-pay-script'
export const GOOGLE_PAY_SCRIPT_URL = 'https://pay.google.com/gp/p/js/pay.js'
export const DEFAULT_GATEWAY = 'verygoodsecurity'
export const DEFAULT_MERCHANT_ID = 'BCR2DN4TUSHMLW3R'
export const DEFAULT_GATEWAY_MERCHANT_ID = 'ACkXpaU1qFuSz9ukJaAqjzg5'
export const TOKEN_TYPE = 'PAYMENT_GATEWAY'
export const baseCardPaymentMethod: google.payments.api.PaymentMethodSpecification = {
  type: 'CARD',
  parameters: {
    allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
    allowedCardNetworks: ['MASTERCARD', 'VISA'],
  },
  tokenizationSpecification: {
    type: TOKEN_TYPE,
    parameters: {
      gateway: DEFAULT_GATEWAY,
      gatewayMerchantId: DEFAULT_GATEWAY_MERCHANT_ID,
    },
  },
}
export const baseRequestToGP: google.payments.api.IsReadyToPayRequest = {
  apiVersion: 2,
  apiVersionMinor: 0,
  allowedPaymentMethods: [baseCardPaymentMethod],
}
